<template>
  <main id="try" class="pb-5">
    <WordsInput/>
    <GeneratorSettings/>
    <ActionButtons/>
    <Results/>
  </main>
</template>

<script>
import WordsInput from './components/WordsInput.vue'
import GeneratorSettings from './components/GeneratorSettings';
import Results from './components/Results';
import ActionButtons from '@/components/ActionButtons';

export default {
  name: 'app',
  components: {
    WordsInput,
    GeneratorSettings,
    Results,
    ActionButtons
  },
}
</script>

<style lang="scss">
  body {
    background-color: white;
    font-family: 'Lexend Deca', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
